import { Label, PhoneInput } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";
import { useTranslation } from "react-i18next";
import { FieldDescription } from "../FieldDescription";

export interface PhoneFieldProps extends TellescopeFormFieldBaseProps<"phone"> {}

export const PhoneField = ({
  title,
  description,
  htmlDescription,
  value,
  onChange,
  className,
  error,
  onBlur,
  touched,
  disabled,
  required,
  placeholder,
  autoFocus,
}: PhoneFieldProps) => {
  const { t } = useTranslation("forms");
  const showError = !!(error && touched);
  const resolvedPlaceholder = placeholder ?? t("Enter phone number...");

  return (
    <div className="space-y-1">
      <Label required={required}>{title || resolvedPlaceholder}</Label>
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <PhoneInput
        allowInternational
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={cn(className, showError && "border-destructive")}
        aria-invalid={showError}
        placeholder={resolvedPlaceholder}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
